import React, { useContext } from 'react';
import { isLocked, useIsEntitledQuery } from '@annunciate/query';
import * as Carousels from '../../carousel';
import { Card } from '../../shared';
import { Image } from '../../shared/Image';
import { NavigationContext } from '../../../providers';
export const UnmemoizedTileItem = ({ index, item: collectionItem, widthConstraint, padding = 14, }) => {
    const { onNavigateToItem: onPress } = useContext(NavigationContext);
    const { id, item } = collectionItem;
    const isEntitled = useIsEntitledQuery(item);
    const halfPadding = padding / 2;
    if (item === undefined) {
        return React.createElement(Card, { isLoading: true });
    }
    switch (item.__typename) {
        case 'Content':
        case 'Collection':
            const typed = item;
            const uri = typed?.cover?.src;
            return (React.createElement(Card, { key: id, uri: uri, item: item, isLocked: isLocked({ isEntitled, item }), onPress: () => onPress && onPress(typed), containerStyle: {
                    marginTop: 20,
                    marginLeft: halfPadding,
                    marginRight: halfPadding
                }, disableMarginScaling: true, widthConstraint: widthConstraint ? widthConstraint - padding : widthConstraint, ImageComponent: Image }));
        case 'Carousel':
            return React.createElement(Carousels.Standard, { key: id, index: index, carousel: item });
        default:
            return null;
    }
};
export const TileItem = React.memo(UnmemoizedTileItem, ({ item: { item: prevItem }, widthConstraint: prevWC, index: prevIdx }, { item: { item: nextItem }, widthConstraint: nextWC, index: nextIdx, }) => {
    const isItemIdIdentical = prevItem?.id === nextItem?.id;
    const isIdenticalWC = prevWC === nextWC;
    return isItemIdIdentical && prevIdx === nextIdx && isIdenticalWC;
});
//# sourceMappingURL=TileItem.js.map